import { Skeleton, SkeletonProps } from '@mantine/core';

import cx from './Dashboard.module.scss';

const DashboardSkeletonBlock = (props: SkeletonProps) => <Skeleton radius="xs" className={cx.skeleton} {...props} />;

export { DashboardSkeletonBlock };
